import Iconify from 'src/components/Iconify';
import { useDispatch } from 'src/redux/store';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { openModal } from 'src/redux/slices/modal';
import modals from 'src/constants/modals';
import { pinTransaction, selectTransactionOverview, selectTransactionSlice } from 'src/redux/slices/transaction';
import InvitationModal from 'src/pages/transactions/modals/InvitationModal';
import { AskPriceModal } from 'src/pages/transactions/modals/AskPriceModal';
import { selectUserSettings } from 'src/redux/slices/auth';
import { useMemo } from 'react';
import { selectDocumentsField } from 'src/redux/slices/documents';
import { UpdatePropertyModal } from 'src/pages/transactions/modals/UpdatePropertyModal';
import { OrderSalePackModal } from 'src/pages/transactions/modals/OrderSalePack';
import { ActionButtonItem, ActionButtons } from '../styles';

const AdminTransactionActionButtons = () => {
	const { id = '' } = useParams();
	const dispatch = useDispatch();
	const settings = useSelector(selectUserSettings);
	const { currentTab } = useSelector(selectTransactionSlice);
	const transaction = useSelector(selectTransactionOverview);
	const { isInitialized: areDocumentsInitialized } = useSelector(selectDocumentsField);

	const isPinned = useMemo(
		() => settings.pinnedTransactions.some((transactionRef) => transactionRef.id === id),
		[settings.pinnedTransactions],
	);

	const isParticipants = currentTab === 'participants';
	const isDocuments = currentTab === 'documents';

	const handleQrCode = () => dispatch(openModal({ name: modals.transactionQrCode }));
	const handleAddParticipant = () => dispatch(openModal({ name: modals.invitation }));
	const handleAddAskPrice = () => dispatch(openModal({ name: modals.askPrice }));
	const handleEditAskPrice = () =>
		dispatch(openModal({ name: modals.askPrice, payload: { price: transaction.askPrice?.price } }));
	const handlePin = async () => {
		await dispatch(pinTransaction({ id, isPinned }));
	};

	const handleAddFolder = () => dispatch(openModal({ name: modals.addDocumentsFolder }));
	const handleUpdateState = () => dispatch(openModal({ name: modals.updateTransactionState }));
	const handleOrderSalePack = () => dispatch(openModal({ name: modals.orderSalePack }));

	if (
		transaction.state === 'ARCHIVED' ||
		transaction.state === 'DEFUNCT' ||
		transaction.state === 'FALL_THROUGH' ||
		transaction.state === 'WITHDRAWAL' ||
		transaction.state === 'ERROR'
	) {
		return null;
	}

	if (transaction.state === 'STANDBY') {
		return (
			<ActionButtons>
				<ActionButtonItem onClick={handleUpdateState}>
					<Iconify icon='grommet-icons:book' fontSize={18} />
					Set state
				</ActionButtonItem>
			</ActionButtons>
		);
	}

	return (
		<ActionButtons>
			<ActionButtonItem onClick={handlePin}>
				<Iconify icon={isPinned ? 'lucide:pin-off' : 'lucide:pin'} fontSize={25} />
				{isPinned ? 'Unpin' : 'Pin'}
			</ActionButtonItem>
			{isParticipants && (
				<ActionButtonItem onClick={handleAddParticipant}>
					<Iconify icon='zondicons:add-outline' fontSize={20} />
					Add Participant
				</ActionButtonItem>
			)}
			{isParticipants && (
				<ActionButtonItem onClick={handleQrCode}>
					<Iconify icon='bx:qr' fontSize={18} />
					Create QR code
				</ActionButtonItem>
			)}
			{transaction.askPrice ? (
				<ActionButtonItem onClick={handleEditAskPrice}>
					<Iconify icon='mdi:edit' fontSize={20} />
					Edit price
				</ActionButtonItem>
			) : (
				<ActionButtonItem onClick={handleAddAskPrice}>
					<Iconify icon='solar:tag-price-bold' fontSize={20} />
					Set price
				</ActionButtonItem>
			)}
			{(transaction.hasPendingSellSideAgent || transaction.hasValidSellSideAgentPlaceholder) &&
				!transaction.isSalePackOrdered && (
					<ActionButtonItem onClick={handleOrderSalePack}>
						<Iconify icon='stash:pack' fontSize={20} />
						Order Sale Pack
					</ActionButtonItem>
				)}
			<ActionButtonItem onClick={handleUpdateState}>
				<Iconify icon='grommet-icons:book' fontSize={18} />
				Set state
			</ActionButtonItem>
			{isDocuments && areDocumentsInitialized && (
				<ActionButtonItem onClick={handleAddFolder}>
					<Iconify icon='material-symbols:add-circle-outline-rounded' fontSize={18} />
					Add Folder
				</ActionButtonItem>
			)}
			<InvitationModal />
			<AskPriceModal />
			<UpdatePropertyModal />
			<OrderSalePackModal />
		</ActionButtons>
	);
};

export default AdminTransactionActionButtons;
